// 获取新闻导航channelId
export const GETNEWSCHANNELID = 'get-news-channel-id'

// 获取热门新闻
export const GETHOTNEWS = 'get-hot-news'

// 新闻新闻列表
export const GETNEWSLIST = 'get-news-list'

// 获取跟多新闻
export const GETMORENEWS = 'get-more-news'

// 获取作者信息
export const GETAUTHORINFO = 'get-author-info'

// 获取作者列表
export const GETAUTHORLIST = 'get-author-list'

// 获取专题列表
export const GETFEATURELIST = 'get-feature-list'

// 获取 更多的专题列表
export const GETMOREFEATURELIST = 'get-more-feature-list'

// 获取24H热门新闻
export const GET24HNEWSLIST = 'get-24h-news-list'
